:host {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;

  .hide {
    display: none;
  }

  .chat-message {
    border-radius: 0 10px 10px 10px;

    &__user {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      module-avatar-component,
      img,
      &--avatar {
        margin-right: 10px;
      }

      span {
        color: #fb472e;
        font-size: 15px;
        font-weight: 600;
      }

      &--avatar {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        object-fit: contain;
      }

      img {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        object-fit: contain;
        filter: invert(55%) sepia(81%) saturate(6447%) hue-rotate(346deg) brightness(109%)
          contrast(97%);
      }
    }

    &__message {
      margin-bottom: 10px;

      div:first-child {
        box-sizing: border-box;
        display: inline-block;
        width: auto;
        padding: 20px 18px;
        border-radius: 0 10px 10px 10px;
        color: white;
        background-color: #fb472e;
        max-width: 60%;
      }
    }
  }

  .error {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 60%;
    margin: auto;

    img {
      margin-bottom: 20px;
    }

    p {
      color: #333333;
      color: var(--font-primary);
      font-size: 16px;
      letter-spacing: 0;
      line-height: 20px;
      text-align: center;
      margin-bottom: 10px;
    }

    &__redirect {
      color: #666666;
      color: var(--font-secondary);
      margin-bottom: 5px;
    }

    span {
      color: #0098ff;
      color: var(--blue);
      font-size: 12px;
      cursor: pointer;
    }

    &--full {
      background: white;
      background: var(--bg-primary);
      padding: 30px;
      border-radius: 6px;
    }
  }

  .writing-loader {
    margin: 0 15px;
  }
}
